// Open modal if present in DOM
const overdueInvoicesModalEl = document.getElementById("overdue-invoices-modal");
if (overdueInvoicesModalEl) {
    $(overdueInvoicesModalEl).modal("show");
}

// Block cart when user has overdue invoices
const baseEl = document.querySelector(".l-base");
const isCartBlocked = baseEl?.dataset.cartBlocked === "true";

if (isCartBlocked && overdueInvoicesModalEl) {
    document.addEventListener(
        "click",
        (event) => {
            const cartButton = event.target.closest(".products__buy");
            if (cartButton) {
                event.preventDefault();
                event.stopPropagation();
                $(overdueInvoicesModalEl).modal("show");
            }
        },
        true
    );
}
